import { List } from "immutable"
import { Action, any, async, AsyncState, fromJSX, nothing, stateful } from "widgets-for-react"
import { previousOrDefault } from "../../../custom_api/api_utils"
import { CollectionItem } from "../../../custom_api/generated"
import { noOp } from "../../../custom_utils/helpers"
import { BookProps, BooksBlock } from "../books_block"
import { initialThemakiezerBlockState, ThemakiezerBlockProps, ThemakiezerBlockState } from "./ThemakiezerBlockState"

export const ThemakiezerBlock = (props: ThemakiezerBlockProps) =>
  stateful()((state: ThemakiezerBlockState) =>
    any<Action<ThemakiezerBlockState>>({ key: `ThemakiezerBlock-${props.embedId}` })([

      state.books.kind == 'loaded'
        ? fromJSX(() => BooksBlock({ ...props, kind: 'books', books: bookProps(state.books) }))
        : nothing(),

      async<CollectionItem[]>(nothing, { key: 'ThemakiezerLoader' })(state.books)
        .map(resultUpdater => (s0): ThemakiezerBlockState => ({ ...s0, books: resultUpdater(s0.books) }))

    ]).map(a => a(state))
  )(initialThemakiezerBlockState(props)).run(noOp)

const bookProps = (items: AsyncState<CollectionItem[]>): List<BookProps> =>
  List(previousOrDefault(items, [])).map(b => ({
    title: b.title,
    author: b.authors[0],
    imageUrl: b.imageUrls["w245"],
    imageAlt: `Kaft van ${b.title} door ${b.authors[0]}`,
    url: b.originalUrl
  })).toList()